import React, { Component } from "react";
import "../App.css";
import profile from "../images/profile.png";
import logo from "../images/logo.png";
import { Link } from "react-router-dom";

class NavBar extends Component {
  render() {
    return (
      <nav className="NavContainer">
        <div className=" Logo_container">
          <Link to="/">
            <img className="logo" src={logo} alt="logo"></img>
          </Link>
        </div>
        <div className="Link_container">
          <Link to="/mindfulness" style={{ textDecoration: "none" }}>
            <h2 className="NavTag">Mindfulness</h2>
          </Link>
          <Link to="#" style={{ textDecoration: "none" }}>
            <h2 className="NavTag">Escape</h2>
          </Link>
          <Link to="#" style={{ textDecoration: "none" }}>
            <h2 className="NavTag">Environment</h2>
          </Link>
          <Link to="#" style={{ textDecoration: "none" }}>
            <h2 className="NavTag">Vitality</h2>
          </Link>
        </div>

        <div className="Profile_container">
          <Link to="/my-profile" className="NavTag">
            Login/ Signup
          </Link>
          <img src={profile} className="profile-img" alt="login"></img>
        </div>
      </nav>
    );
  }
}

export default NavBar;
